// extracted by mini-css-extract-plugin
export var modal = "_v4-0";
export var table = "_v4-1";